<template>
  <div
    class="w-full flex flex-col tablet-h:flex-row border border-green-700/25 bg-green-200/25 tablet-h:items-center rounded-md font-secondary text-[14px] leading-[20px] text-gray-500 mb-[18px] tablet-h:mb-[9px] font-medium gap-y-1.5"
  >
    <Pill class="mr-[15px]" variant="success">
      {{ billingStore.billing?.upsell?.pillText }}
    </Pill>
    <div>
      {{ format(billingStore.billing?.upsell?.text) }}
      <span class="text-link" @click="handleClick">
        {{ billingStore.billing?.upsell?.ctaText }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { usePlansQueryQuery } from '@/shared/graphql/legacy/generated'
import { useBillingStore } from '@/features/billing/store'
import { SelectPlanType } from '@/shared/types/index'
import { Pill } from '@dacr/library'
import { analytics } from '@/shared/services/analytics'
import { useRouter } from 'vue-router'

const { result } = usePlansQueryQuery()

const router = useRouter()
const billingStore = useBillingStore()

const format = (text?: string) => {
  if (!text) return
  return text.replace(
    '<price>',
    billingStore.billing?.upsell?.planItem.prices?.[0]?.details
      ?.renderedPrice || ''
  )
}

const handleClick = () => {
  if (
    !billingStore.billing?.upsell?.plan ||
    !billingStore.billing.upsell.planItem
  )
    return

  analytics.track('upsell_cta_clicked', {
    amount:
      (billingStore.billing.upsell.planItem.prices?.[0]?.details?.amount || 0) /
      100,
    currency:
      billingStore.billing.upsell.planItem.prices?.[0]?.details?.currency,
  })

  const billingCycle =
    billingStore.billing.upsell.planItem.prices[0].details?.billingCycleType ||
    'month'

  billingStore.setPlanData({
    plan: billingStore.billing?.upsell?.plan,
    planItem: billingStore.billing?.upsell?.planItem,
    billingCycle: {
      type: billingCycle,
      description:
        result.value?.plans?.groupByBillingCycle.find(
          (cycle) => cycle?.billingCycleType === billingCycle
        )?.billingCycleDescription || '',
    },
  })

  router.push(`/${SelectPlanType.Change}/checkout`)
}
</script>
